import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { TrendingDown, TrendingUp, Minus } from 'lucide-react';

const fC = (v) => {
  if (!v || v === 0) return '₹0';
  const n = Number(v);
  if (Math.abs(n) >= 10000000) return `₹${(n / 10000000).toFixed(2).replace(/\.?0+$/, '')}Cr`;
  if (Math.abs(n) >= 100000) return `₹${(n / 100000).toFixed(1).replace(/\.?0+$/, '')}L`;
  return `₹${n.toFixed(0)}`;
};

export default function DivisionDeltaChip({ divisionId }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/divisions/${divisionId}/history`).then(r => setData(r.data)).catch(() => {});
  }, [divisionId]);

  if (!data || !data.bars || data.bars.length < 2) return null;

  // Find last two actual years
  const actuals = data.bars.filter(b => b.type === 'actual');
  if (actuals.length < 2) return null;
  const current = actuals[actuals.length - 1];
  const prior = actuals[actuals.length - 2];
  const delta = (current.value || 0) - (prior.value || 0);
  const pct = prior.value > 0 ? (delta / prior.value) * 100 : 0;
  const isUp = delta > 0;
  const isFlat = Math.abs(pct) < 1;

  const palette = isFlat
    ? { text: '#6B7280', bg: '#F3F4F6', icon: Minus, sign: '' }
    : isUp
    ? { text: '#2D8B5E', bg: '#ECFDF5', icon: TrendingUp, sign: '+' }
    : { text: '#D4726A', bg: '#FEF2F2', icon: TrendingDown, sign: '' };
  const Icon = palette.icon;

  return (
    <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold" style={{ backgroundColor: palette.bg, color: palette.text }} title={`${prior.label} ₹${(prior.value / 1e7).toFixed(2)}Cr → ${current.label} ₹${(current.value / 1e7).toFixed(2)}Cr`} data-testid="division-delta-chip">
      <Icon size={11} />
      <span>{palette.sign}{fC(delta)} vs {prior.label}</span>
      {!isFlat && <span className="opacity-70">({palette.sign}{pct.toFixed(1)}%)</span>}
    </div>
  );
}
